// import React from 'react';

// const WithWhatsapp = ({ number, name }) => {
// 	return (
// 		<div style={{ padding: "10px", backgroundColor: "#fff" }}>
// 			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{number}</span>
// 			<br />
// 			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{name}</span>
// 			<div style={{ flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10 }}>
// 				<a style={{ padding: "10px", borderRadius: "10px" }}
// 					href={`https://wa.me/977${number}?span=नमस्ते Network Educational Academy 🙏`
// 					}
// 				>
// 					<span>
// 						<i className="fa fa-whatsapp" style={{ fontSize: 30 }} />
// 					</span>
// 				</a>
// 				<a style={{ padding: "10px", borderRadius: "10px" }}
// 					// 				href={`viber://chat/?number=${number}?text=
// 					// नमस्ते Network Educational Academy 🙏
// 					// म Network Educational Academyको प्रयोगकर्ता हुँ।
// 					// `
// 					href={`viber://chat?number=977${number}`}

// 				>
// 					<span>
// 						<img src='https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/viber.jpg' className="fa fa-viber" style={{ width: "50px" }} />
// 					</span>
// 				</a>
// 				<a style={{ padding: 10, borderWidth: 0.5, borderColor: "#ddd", borderRadius: 10 }}
// 					href={`tel:${number}`}
// 				>
// 					<span>
// 						<i className="fa fa-phone" style={{ fontSize: 30 }} />
// 					</span>
// 				</a>
// 			</div>
// 		</div>
// 	)
// }


// const WithoutWhatsapp = ({ number }) => {
// 	return (
// 		<div>
// 			<span style={{ spanAlign: 'center', fontSize: 18, fontWeight: 'bold' }}>{number}</span>
// 			<div style={{ flexDirection: 'row', justifyContent: 'space-evenly', marginTop: 10 }}>
// 				<a style={{ padding: 10, borderWidth: 0.5, borderColor: "#ddd", borderRadius: 10 }}
// 					href={`tel:${number}`}
// 				>
// 					<span>
// 						<i className="fa fa-phone" style={{ fontSize: 30 }} />
// 					</span>
// 				</a>
// 			</div>
// 		</div>
// 	)
// }


// export default function ContactUS() {
// 	return (
// 		<div className='row'>
// 			<div className="row">
// 				{/* {loginSuccess &&
// 			<Navigate to="/" />
// 		} */}
// 				<div className="col-lg-2 col-1"></div>
// 				<div className="col-lg-8 col-10 shadow signin-container" style={{ backgroundColor: "#fff" }}>

// 					<div>
// 						<div style={{ backgroundColor: "#fff", borderColor: "#bbb", borderWidth: 1, margin: 10, padding: 10 }}>
// 							<span style={{ spanAlign: "center" }}>
// 								{/* तपाई पहिलो पटक Network Educational Academy तल दिईएको सम्पर्क नम्बरमा सम्पर्क गर्नु  होला |{"\n"} */}
// 								Network Educational Academy - लोकसेवा नेटवर्क - NEA मा भइरहेका तयारी कक्षामा जोडिन चाहनुहुन्छ भने थप जानकारीको लागि दिइएको सम्पर्क नम्बरमा Phone अथवा WhatsApp /Viber मा सम्पर्क गर्नुहोला ।
// 							</span>
// 						</div>
// 						<div style={{ display: 'flex' }}>
// 							<div style={{ width: "100%", borderColor: "#bbb", borderWidth: 1, padding: 10, margin: 10, marginTop: 0, backgroundColor: "#fff" }}>

// 								<div className='row'>
// 									<div className='col-md-6'>
// 										<WithWhatsapp number={"9844832140"} name="R.K. sir" />
// 									</div>
// 									<div className='col-md-6'>
// 										<WithWhatsapp number={"9844085262"} name="Nirajan Sir" />
// 									</div>

// 								</div>
// 							</div>

// 						</div>
// 						<div style={{ width: "66%", borderColor: "#bbb", borderWidth: 1, padding: 10, margin: 10, marginTop: 0, backgroundColor: "#fff" }}>
// 							<span style={{ spanAlign: "left" }}>
// 								Landline :
// 							</span>
// 							<div className='row'>
// 								<div className='col-md-6'>
// 									<WithoutWhatsapp number={"01-5921577"} />
// 								</div>
// 							</div>
// 						</div>
// 						<div style={{ marginVertical: 10, margin: 5, padding: 10, borderWidth: 1, backgroundColor: `#fff`, borderRadius: 10 }}>
// 							<div style={{ flexDirection: "row" }}>
// 								<div className='col-md-4'>
// 									<div style={{ width: "100%", justifyContent: "center" }}>
// 										<img src={`https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/viber-2.jpg`} style={{ width: "100%", }} resizeMode="contain" />
// 									</div>
// 								</div>
// 							</div>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	)
// }



import React from "react";

const message = encodeURIComponent(
  "नमस्ते Network Educational Academy 🙏 म Network Educational Academy को प्रयोगकर्ता हुँ।"
);

const ContactPerson = ({ number, name }) => {
  return (
    <article className="support-card">
      <div className="support-avatar">
        {name.charAt(0)}
      </div>

      <div className="support-person">
        <h3>{name}</h3>

        <a
          href={`tel:+977${number}`}
          className="support-phone"
        >
          +977 {number}
        </a>
      </div>

      <div className="support-actions">
        <a
          href={`https://wa.me/977${number}?text=${message}`}
          target="_blank"
          rel="noopener noreferrer"
          className="support-action support-whatsapp"
          aria-label={`WhatsApp ${name}`}
        >
          <i
            className="fa fa-whatsapp"
            aria-hidden="true"
          />
          <span>WhatsApp</span>
        </a>

        <a
          href={`viber://chat?number=%2B977${number}`}
          className="support-action support-viber"
          aria-label={`Viber ${name}`}
        >
          <img
            src="https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/viber.jpg"
            alt=""
          />
          <span>Viber</span>
        </a>

        <a
          href={`tel:+977${number}`}
          className="support-action support-call"
          aria-label={`Call ${name}`}
        >
          <i
            className="fa fa-phone"
            aria-hidden="true"
          />
          <span>Call</span>
        </a>
      </div>
    </article>
  );
};

export default function ContactUS() {
  return (
    <section className="support-section">
      <div className="support-section-header">
        <div>
          <span className="support-badge">
            Contact support
          </span>

          <h2>Need help getting started?</h2>

          <p>
            Network Educational Academy - लोकसेवा नेटवर्क -
            NEA मा भइरहेका तयारी कक्षामा जोडिन चाहनुहुन्छ
            भने थप जानकारीका लागि Phone, WhatsApp वा Viber
            मा सम्पर्क गर्नुहोस्।
          </p>
        </div>
      </div>

      <div className="support-grid">
        <ContactPerson
          number="9844832140"
          name="R.K. Sir"
        />

        <ContactPerson
          number="9844085262"
          name="Nirajan Sir"
        />
      </div>

      <div className="support-bottom-grid">
        <article className="office-contact-card">
          <div className="office-contact-icon">
            <i
              className="fa fa-phone"
              aria-hidden="true"
            />
          </div>

          <div>
            <span>Office landline</span>

            <a href="tel:01-5921577">
              01-5921577
            </a>
          </div>

          <a
            href="tel:01-5921577"
            className="office-call-button"
          >
            Call office
          </a>
        </article>

        <article className="payment-card">
          <div className="payment-content">
            <span className="payment-label">
              Payment
            </span>

            <h3>Scan to pay</h3>

            <p>
              Scan the QR code using your supported mobile
              banking or payment application.
            </p>
          </div>

          <div className="payment-qr-wrapper">
            <img
              src="https://api.networkeducationalacademy.com/wp-content/uploads/2025/09/viber-2.jpg"
              className="payment-qr"
              alt="Network Educational Academy payment QR"
            />
          </div>
        </article>
      </div>
    </section>
  );
}